import { TypePolicy } from '@apollo/client'

export const projectElementNodeTypePolicy = {
    ProjectElementNode: {
        keyFields: false,
    } as TypePolicy,
}
